import { ServerStatusEnum } from 'api/servers/servers.eum';
import { Server } from 'api/servers/servers.types';

export const findServerToExpand = (servers: Server[]) => {
  const firstConnectedServer = servers.filter((server) => server.status === ServerStatusEnum.POLACZONY)[0];

  return firstConnectedServer || servers[0];
};
